import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "hidden lg:inline-block" }
const _hoisted_3 = {
  key: 0,
  class: "flex mr-2"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "hidden lg:inline-block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "publish", -1)
const _hoisted_7 = { class: "hidden lg:inline-block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "publish", -1)
const _hoisted_9 = { class: "hidden lg:inline-block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "download", -1)
const _hoisted_11 = { class: "hidden lg:inline-block" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-middle text-slate-500" }, "delete", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.history.data.is_public)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleEditMode())),
            class: "mr-2 cursor-pointer"
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("history.edit")), 1),
            _createElementVNode("i", {
              class: _normalizeClass(["material-icons align-middle text-slate-500 transform transition-transform", _ctx.is_edit_mode ? 'rotate-180' : ''])
            }, "expand_more", 2)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.is_edit_mode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.history.data.is_public)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("a", {
                    href: `https://twitter.com/intent/tweet?text=${_ctx.twitter_text}&url=${_ctx.public_url}&hashtags=instagraph`,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("history.share")), 1),
                    _hoisted_6
                  ], 8, _hoisted_4),
                  _createElementVNode("i", {
                    class: "material-icons align-middle text-slate-500",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clip()))
                  }, "content_copy")
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "flex mr-2 cursor-pointer",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAttempt('publish')))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("history.share")), 1),
                  _hoisted_8
                ])),
            _createElementVNode("div", {
              class: "flex mr-2 whitespace-nowrap cursor-pointer",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadToggle && _ctx.downloadToggle(...args)))
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("history.download")), 1),
              _hoisted_10
            ]),
            (!_ctx.history.data.is_public)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "flex ml-4 cursor-pointer",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAttempt('delete')))
                }, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("history.delete")), 1),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}